var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQkc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11.664c-.267.07-.531.359-.642.513l-2.867 3.698c.931 1.233 2.838 3.743 3.02 3.925.16.16.374.255.49.29.116-.035.33-.13.49-.29.182-.181 2.089-2.692 3.02-3.925l-2.868-3.698c-.11-.154-.375-.444-.642-.513zm.038 10.928h-.453c-.242 0-.554-.352-.68-.528l-3.622-4.755c-2.24 2.917-6.792 8.814-7.094 9.056-.379.302-1.058.377-1.51.226-.363-.12-.605-.755-.68-1.057V6.29c.05-.402.302-1.222.906-1.283.603-.06 1.107.277 1.283.453l7.093 8.755c1.157-1.51 3.547-4.604 3.85-4.906.254-.256.633-.313.867-.31.233-.003.613.054.868.31.302.3 2.692 3.395 3.85 4.905L27.81 5.46c.177-.176.68-.513 1.284-.453.604.06.856.88.906 1.283v19.245c-.076.302-.317.936-.68 1.057-.452.15-1.131.076-1.509-.226-.3-.242-4.854-6.139-7.093-9.057l-3.623 4.754c-.125.176-.437.528-.679.528h-.377zm11.245-13.51-5.359 6.793c-.24 0 3.472 4.428 5.36 6.642V9.083zm-22.566 0 5.358 6.793c.242 0-3.471 4.428-5.358 6.642V9.083z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQkc);
export default __webpack_public_path__ + "static/media/QKC.55d93df097e354a629891fd8cba819a4.svg";
export { ForwardRef as ReactComponent };